import { gql } from "@apollo/client";

export const CLIENT_COMMENTS_BY_CLIENT_QUERY = gql`
  query ClientCommentsByClient($clientId: Int!, $limit: Int, $page: Int) {
    clientCommentsByClient(clientId: $clientId, limit: $limit, page: $page) {
      id
      text
      user {
        id
        userName
      }
      createdAt
      updatedAt
    }
  }
`;
